import { makeAutoObservable } from 'mobx';
import React from 'react';

export type Breadcrumb = {
  url: string;
  title: string;
  badge?: {
    text: string;
    color: 'grey' | 'green' | 'yellow' | 'orange' | 'teal' | 'red';
    tooltip?: string;
    icon?: React.ElementType;
  };
};

class BreadcrumbsStore {
  breadcrumbs: Breadcrumb[] = [{ url: '/', title: 'Home' }];

  constructor() {
    makeAutoObservable(this);
  }

  set(crumbs: Breadcrumb[]): void {
    this.breadcrumbs = crumbs;
  }

  pop(): void {
    this.breadcrumbs.pop();
  }

  push(crumb: Breadcrumb): void {
    this.breadcrumbs.push(crumb);
  }

  update(index: number, crumb: Breadcrumb): void {
    this.breadcrumbs[index] = crumb;
  }
}

export default BreadcrumbsStore;
